export class BaseChart {
    constructor({
        // IDENTIFICACIÓN
        seriesId = 'generic-series',            // ID único de la serie (ej: 'ventas-2024')
        seriesName = 'Serie',                   // Nombre visible en leyendas y tooltips

        // TÍTULO
        title = '',                             // Título principal del gráfico
        subtitle = '',                          // Subtítulo o descripción adicional
        subtitleLink = '',                      // URL clickeable en el subtítulo (opcional)
        titleLeft = 'center',                   // Posición horizontal del título: 'left' | 'center' | 'right' | px | %
        titleTop = 'top',                       // Posición vertical del título: 'top' | 'middle' | 'bottom' | px | %
        titleFontSize = 15,                     // Tamaño de fuente del título
        subtitleFontSize = 12,                  // Tamaño de fuente del subtítulo

        // TOOLTIP - INFORMACIÓN EMERGENTE
        showTooltip = true,                     // Mostrar/ocultar tooltip (true/false)
        tooltipFormatter = null,                // Función o string para formatear contenido; null usa el valor por defecto. Ej: (p)=>`<b>${p.name}</b>: ${p.value}` o '{b}: {c}'
        tooltipTrigger = 'item',                // Qué activa el tooltip: 'item' | 'axis' | 'none'
        tooltipAxisPointer = 'line',            // Tipo de puntero (solo con trigger='axis'): 'line' | 'shadow' | 'cross' | 'none'
        tooltipBackgroundColor = 'rgba(47, 53, 58, 1)',   // Color fondo: '#333' | 'rgba(50,50,50,0.95)' | 'black'
        tooltipBorderColor = 'rgba(47, 53, 58, 1)',   // Color del borde: '#333' | '#fff' | 'transparent'
        tooltipTextStyle = { color: '#fff' },   // Estilo del texto: { color, fontSize, fontWeight, etc. }

        // LABELS
        showLabel = false,              // Mostrar etiquetas por defecto
        labelPosition = 'top',          // 'top', 'left', 'right', 'bottom', 'inside', 'outside'
        labelFontSize = 12,             // <--- AQUÍ ESTÁ LO QUE BUSCAS
        labelColor = null,              // null = color automático de la serie
        labelFontWeight = 'normal',     // 'normal', 'bold', 'bolder', 'lighter', 100-900
        labelPadding = [0, 0, 0, 0],    // Padding del texto

        // LEYENDA
        showLegend = true,                      // Mostrar/ocultar leyenda (true/false)
        legendData = null,                        // Nombres en la leyenda; vacío = automático. Ej: ['Ventas', 'Gastos']
        legendOrient = 'horizontal',            // Orientación: 'horizontal' | 'vertical'
        legendLeft = 'center',                  // Posición horizontal: 'left' | 'center' | 'right' | numérico
        legendTop = 'bottom',                   // Posición vertical: 'top' | 'middle' | 'bottom' | numérico
        legendFontSize = 11,                    // Tamaño de la letra
        legendItemSize = 14,                    // Tamaño del icono (cuadradito/círculo)

        // GRID - MÁRGENES DEL ÁREA DE DIBUJO
        gridLeft = '3%',                       // Margen izquierdo ('10%' | 50 | 'auto')
        gridRight = '4%',                      // Margen derecho, útil si hay etiquetas o leyendas a la derecha
        gridTop = '15%',                        // Margen superior, deja espacio para título o etiquetas
        gridBottom = '12%',                     // Margen inferior, deja espacio para eje X o leyendas
        gridContainLabel = true,                // Ajuste automático del grid (true=recomendado)

        // VISUAL MAP - ESCALA DE COLORES
        showVisualMap = false,                  // Mostrar/ocultar escala de colores (true/false)
        visualMapMin = 0,                       // Valor mínimo del rango de color
        visualMapMax = 100,                     // Valor máximo del rango de color
        visualMapLeft = 'left',                 // Posición horizontal: 'left' | 'center' | 'right' | numérico
        visualMapTop = 'bottom',                // Posición vertical: 'top' | 'middle' | 'bottom' | numérico
        visualMapOrient = 'vertical',           // Orientación: 'vertical' | 'horizontal'
        visualMapText = ['Alto', 'Bajo'],       // Etiquetas de extremos: [max, min]
        visualMapFontSize = 10,                 // Tamaño texto visual map
        visualMapItemWidth = 18,                // Ancho de la barra de color
        visualMapItemHeight = 85,              // Alto de la barra de color
        visualMapCalculable = true,             // Permitir ajuste interactivo del rango (true/false)
        visualMapInvert = false,                // Invertir dirección de colores (true/false)
        colorRange = ['#F0F2F0', '#000C40'],    // Colores del gradiente [min→max]
        // COLOR PALETTE - PALETA DE COLORES
        colorPalette = [                        // Paleta general de colores (usada si no se especifica un color individual)
            '#1565C0', '#a17fe0', '#ffff1c', '#c31432', '#12c2e9',
            '#59C173', '#FDC830', '#9a60b4', '#ea7ccc', '#d14a61'
        ],

        // ANIMACIONES
        universalTransition = true,             // Transiciones suaves entre estados del gráfico (true/false)
        animationDuration = 1000,               // Duración animación inicial (ms) — 0 = sin animación
        animationDurationUpdate = 1000,         // Duración animación al actualizar datos (ms)
        animationEasing = 'cubicOut',           // Tipo de easing: 'linear' | 'quadraticInOut' | 'cubicOut' | 'bounceOut' | etc.
        animationDelay = 0,                     // Retardo antes de iniciar animación (ms o función ej: (i)=>i*30)
        // EMPHASIS - ESTILO AL RESALTAR
        emphasis = {                            // Estilo al hacer hover/focus
            focus: 'self',                      // 'self' | 'series' | 'adjacency' | 'none'
            label: { show: true, fontSize: 11, fontWeight: 'bold', color: '#000', },
        },

        // BLUR - ESTILO DESENFOCADO
        blur = {                                // Estilo de elementos no enfocados
            itemStyle: { opacity: 0.3 }         // Ej: { itemStyle:{opacity:0.2}, label:{opacity:0.3} }
        },

        // TOOLBOX - BARRA DE HERRAMIENTAS
        showToolbox = true,                     // Mostrar/ocultar barra de herramientas (true/false)
        toolboxFeatures = ['restore', 'saveAsImage'],   // Funciones: 'saveAsImage' | 'restore' | 'dataView' | 'dataZoom' | 'magicType'
        customToolboxButtons = [],
        toolboxIconSize = 12,

        // DATAZOOM - CONTROL DE ZOOM
        showDataZoom = false,                   // Habilitar zoom interactivo (true/false)
        dataZoomStart = 0,                      // Inicio del rango visible (0–100)
        dataZoomEnd = 100,                      // Fin del rango visible (0–100)
        dataZoomType = 'slider',                // Tipo: 'slider' | 'inside' | 'both'
    } = {}) {
        // Identificación
        this.seriesId = seriesId;
        this.seriesName = seriesName;

        // Título
        this.title = title;
        this.subtitle = subtitle;
        this.subtitleLink = subtitleLink;
        this.titleLeft = titleLeft;
        this.titleTop = titleTop;
        this.titleFontSize = titleFontSize;
        this.subtitleFontSize = subtitleFontSize;

        // Tooltip
        this.showTooltip = showTooltip;
        this.tooltipFormatter = tooltipFormatter;
        this.tooltipTrigger = tooltipTrigger;
        this.tooltipAxisPointer = tooltipAxisPointer;
        this.tooltipBackgroundColor = tooltipBackgroundColor;
        this.tooltipBorderColor = tooltipBorderColor;
        this.tooltipTextStyle = tooltipTextStyle;

        // Labels
        this.showLabel = showLabel;
        this.labelPosition = labelPosition;
        this.labelFontSize = labelFontSize;
        this.labelColor = labelColor;
        this.labelFontWeight = labelFontWeight;
        this.labelPadding = labelPadding;

        // Legend
        this.showLegend = showLegend;
        this.legendData = legendData;
        this.legendOrient = legendOrient;
        this.legendLeft = legendLeft;
        this.legendTop = legendTop;
        this.legendFontSize = legendFontSize;
        this.legendItemSize = legendItemSize;

        // Grid
        this.gridLeft = gridLeft;
        this.gridRight = gridRight;
        this.gridTop = gridTop;
        this.gridBottom = gridBottom;
        this.gridContainLabel = gridContainLabel;

        // Visual Map
        this.showVisualMap = showVisualMap;
        this.visualMapMin = visualMapMin;
        this.visualMapMax = visualMapMax;
        this.visualMapLeft = visualMapLeft;
        this.visualMapTop = visualMapTop;
        this.visualMapOrient = visualMapOrient;
        this.visualMapText = visualMapText;
        this.visualMapFontSize = visualMapFontSize;
        this.visualMapItemWidth = visualMapItemWidth;
        this.visualMapItemHeight = visualMapItemHeight;
        this.visualMapCalculable = visualMapCalculable;
        this.visualMapInvert = visualMapInvert;
        this.colorRange = colorRange;

        // Color Palette
        this.colorPalette = colorPalette;

        // Animaciones
        this.universalTransition = universalTransition;
        this.animationDuration = animationDuration;
        this.animationDurationUpdate = animationDurationUpdate;
        this.animationEasing = animationEasing;
        this.animationDelay = animationDelay;

        // Emphasis & Blur
        this.emphasis = emphasis;
        this.blur = blur;

        // Toolbox
        this.showToolbox = showToolbox;
        this.toolboxFeatures = toolboxFeatures;
        this.customToolboxButtons = customToolboxButtons;
        this.toolboxIconSize = toolboxIconSize;

        // DataZoom
        this.showDataZoom = showDataZoom;
        this.dataZoomStart = dataZoomStart;
        this.dataZoomEnd = dataZoomEnd;
        this.dataZoomType = dataZoomType;
    }

    /**
     * Genera la configuración del título del gráfico.
     * @returns {Object} Configuración de título para ECharts
     */
    getTitleConfig() {
        if (!this.title && !this.subtitle) return null;
        return {
            text: this.title,
            subtext: this.subtitle,
            sublink: this.subtitleLink,
            left: this.titleLeft,
            top: this.titleTop,
            textStyle: { fontSize: this.titleFontSize, fontWeight: '600', color: '#333' },
            subtextStyle: { fontSize: this.subtitleFontSize }
        };
    }

    /**
     * Genera la configuración base del tooltip.
     * @param {Function|null} customFormatter - Formateador personalizado opcional
     * @returns {Object} Configuración de tooltip para ECharts
     */
    getTooltipConfig(customFormatter = null) {
        if (!this.showTooltip) return {};

        const config = {
            trigger: this.tooltipTrigger,
            backgroundColor: this.tooltipBackgroundColor,
            borderColor: this.tooltipBorderColor,
            borderWidth: 1,
            textStyle: this.tooltipTextStyle,
            formatter: this.tooltipFormatter || customFormatter,
        };

        // Agregar axisPointer solo si el trigger es 'axis'
        if (this.tooltipTrigger === 'axis' && this.tooltipAxisPointer) {
            config.axisPointer = {
                type: this.tooltipAxisPointer,
            };
        }


        return config;
    }

    /**
     * Genera la configuración estándar para etiquetas (labels)
     * @returns {Object} Configuración label para ECharts
     */
    getLabelStyle() {
        const style = {
            show: this.showLabel,
            position: this.labelPosition,
            fontSize: this.labelFontSize,
            fontWeight: this.labelFontWeight,
            padding: this.labelPadding
        };

        if (this.labelColor) {
            style.color = this.labelColor;
        }

        return style;
    }

    /**
     * Genera la configuración de la leyenda.
     * @returns {Object} Configuración de leyenda para ECharts
     */
    getLegendConfig(dynamicData = null) {
        if (!this.showLegend) return { show: false };
        return {
            show: true,
            data: this.legendData || dynamicData, // Prioriza datos manuales o usa los detectados
            orient: this.legendOrient,
            left: this.legendLeft,
            top: this.legendTop,
            itemGap: 15,
            itemWidth: this.legendItemSize + 4,
            itemHeight: this.legendItemSize,
            textStyle: { fontSize: this.legendFontSize, color: '#666' }
        };
    }

    /**
     * Genera la configuración del grid (márgenes del área de dibujo).
     * @returns {Object} Configuración de grid para ECharts
     */
    getGridConfig() {
        return {
            left: this.gridLeft,
            right: this.gridRight,
            top: this.gridTop,
            bottom: this.gridBottom,
            containLabel: this.gridContainLabel
        };
    }

    /**
     * Genera la configuración del visual map (escala de colores).
     * @returns {Object|null} Configuración de visual map para ECharts, o null si está deshabilitado
     */
    getVisualMapConfig() {
        if (!this.showVisualMap) return null;

        return {
            min: this.visualMapMin,
            max: this.visualMapMax,
            left: this.visualMapLeft,
            top: this.visualMapTop,
            orient: this.visualMapOrient,
            text: this.visualMapText,
            calculable: this.visualMapCalculable,
            inverse: this.visualMapInvert,
            itemWidth: this.visualMapItemWidth,
            itemHeight: this.visualMapItemHeight,
            textStyle: {
                fontSize: this.visualMapFontSize,
            },
            inRange: {
                color: this.colorRange,
            },
        };
    }

    /**
     * Genera la configuración del toolbox (barra de herramientas).
     * @returns {Object} Configuración de toolbox para ECharts
     */
    getToolboxConfig() {
        if (!this.showToolbox) return {};

        const features = {};

        if (this.toolboxFeatures.includes('magicType')) {
            features.magicType = {
                show: true,
                type: ['line', 'bar'],
                title: { line: 'Línea', bar: 'Barra' }
            };
        }

        if (this.toolboxFeatures.includes('dataZoom')) {
            features.dataZoom = {
                show: true,
                title: { zoom: 'Zoom', back: 'Restaurar zoom' }
            };
        }

        if (this.toolboxFeatures.includes('restore')) {
            features.restore = { title: 'Restaurar' };
        }

        if (this.toolboxFeatures.includes('saveAsImage')) {
            features.saveAsImage = { title: 'Guardar imagen' };
        }

        if (this.toolboxFeatures.includes('dataView')) {
            features.dataView = { title: 'Ver datos', readOnly: true };
        }

        this.customToolboxButtons.forEach(button => {
            features[button.name] = { // Por algún motivo los nombres deben comenzar con 'my'
                show: true,
                title: button.title,
                icon: button.icon,
                onclick: button.onclick
            };
        });

        return {
            show: true,
            left: 'left',
            top: 'top',
            feature: features,
            itemSize: this.toolboxIconSize,
        };
    }

    /**
     * Genera la configuración del dataZoom (control de zoom).
     * @param {Array} axisIndex - Índices de los ejes a los que aplicar el zoom (ej: [0])
     * @param {boolean} isHorizontal - true si el zoom es horizontal (eje X), false si es vertical (eje Y)
     * @returns {Array|null} Array de configuraciones de dataZoom, o null si está deshabilitado
     */
    getDataZoomConfig(axisIndex = [0], isHorizontal = true) {
        if (!this.showDataZoom) return null;

        const dataZoom = [];
        const axisKey = isHorizontal ? 'xAxisIndex' : 'yAxisIndex';
        const positionKey = isHorizontal ? 'bottom' : 'right';

        // DataZoom tipo slider (control deslizante visible)
        if (this.dataZoomType === 'slider' || this.dataZoomType === 'both') {
            dataZoom.push({
                type: 'slider',
                show: true,
                [axisKey]: axisIndex,
                start: this.dataZoomStart,
                end: this.dataZoomEnd,
                [positionKey]: 0,
            });
        }

        // DataZoom tipo inside (zoom con scroll/gestos, invisible)
        if (this.dataZoomType === 'inside' || this.dataZoomType === 'both') {
            dataZoom.push({
                type: 'inside',
                [axisKey]: axisIndex,
                start: this.dataZoomStart,
                end: this.dataZoomEnd,
            });
        }

        return dataZoom.length > 0 ? dataZoom : null;
    }

    /**
     * Método abstracto que debe ser implementado por las clases hijas.
     * @throws {Error} Si no se implementa en la clase hija
     */
    getOptions() {
        throw new Error('El método getOptions() debe ser implementado por la clase hija');
    }
}
